import type {
  CreateDonationDafRecommendationInput,
  DonationDafRecommendationResponse,
  DonationFundingConfig,
  HostedPaymentSessionInput,
  HostedPortalSessionInput,
  PaymentModuleId,
} from '@triedge/domain-core';
import { createPaymentsClient } from '@triedge/payments';
import { domainRouterClient } from '../api/domainRouterClient';

const paymentsClient = createPaymentsClient({
  mutate: (operationId, args) => domainRouterClient.mutate(operationId as any, args as any),
});

export const ensureStripeCustomerForModule = (moduleId: PaymentModuleId): Promise<string> =>
  paymentsClient.ensureStripeCustomerForModule(moduleId);

export const createHostedPaymentSession = (input: HostedPaymentSessionInput): Promise<string> =>
  paymentsClient.createHostedPaymentSession(input);

export const createHostedPortalSession = (input: HostedPortalSessionInput): Promise<string> =>
  paymentsClient.createHostedPortalSession(input);

export const createDonationDafRecommendation = (
  input: CreateDonationDafRecommendationInput,
): Promise<DonationDafRecommendationResponse> =>
  paymentsClient.createDonationDafRecommendation(input);

export const getDonationFundingConfig = async (): Promise<DonationFundingConfig> =>
  domainRouterClient.query('getDonationFundingConfig' as any, {
    input: {},
  } as any) as Promise<DonationFundingConfig>;
